var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "files_block resolution" }, [
    _c("div", { staticClass: "card-body py-0 px-4" }, [
      _c(
        "div",
        { staticClass: "d-flex flex-column align-items-center" },
        [
          _vm._l(_vm.items, function (chat) {
            return _c(
              "div",
              { staticClass: "d-flex flex-row w-100 py-4 m-0 w-100" },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "d-inline-block align-middle status status-sm status-success mr-3",
                    on: {
                      click: function ($event) {
                        return _vm.click_photo(chat.user_id)
                      },
                    },
                  },
                  [
                    _c("span", {
                      staticClass:
                        "profile-image profile-image rounded-circle d-block mt-1",
                      style: {
                        "background-image":
                          "url(" + chat.user_info.medium_img + ")",
                        "background-size": "cover",
                      },
                    }),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "mb-0 flex-1 text-dark" }, [
                  _c("div", { staticClass: "d-flex" }, [
                    _c("div", { staticClass: "text-dark fw-500" }, [
                      _vm._v(
                        "\n                            " +
                          _vm._s(chat.fio) +
                          "\n                        "
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      { staticClass: "text-muted fs-xs opacity-70 ml-auto" },
                      [
                        _vm._v(
                          "\n                              " +
                            _vm._s(chat.date_format) +
                            "\n                        "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "text-muted ml-4 cursor-pointer",
                        attrs: { href: "#", title: "delete" },
                        on: {
                          click: function ($event) {
                            return _vm.remove_item(chat.id)
                          },
                        },
                      },
                      [_c("i", { staticClass: "fal fa-trash-alt" })]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "mb-0" }, [
                    _vm._v(
                      "\n                        " +
                        _vm._s(chat.message) +
                        "\n                    "
                    ),
                  ]),
                ]),
              ]
            )
          }),
          _vm._v(" "),
          _c("hr", { staticClass: "m-0 w-100" }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "py-3 w-100" },
            [
              _c("b-form-textarea", {
                staticClass: "form-control",
                staticStyle: { "min-height": "130px" },
                attrs: {
                  state: _vm.text.length >= 2,
                  placeholder: "Додати коментар...",
                  size: "sm",
                },
                model: {
                  value: _vm.text,
                  callback: function ($$v) {
                    _vm.text = $$v
                  },
                  expression: "text",
                },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "text-right" }, [
                _c(
                  "button",
                  {
                    staticClass:
                      "btn btn-lg btn-info waves-effect waves-themed mt-5 mb-5",
                    attrs: { type: "button", disabled: _vm.is_dis_save },
                    on: { click: _vm.add_item },
                  },
                  [
                    _c("span", { staticClass: "fal fa-download mr-1" }),
                    _vm._v(
                      "\n                        Додати\n                    "
                    ),
                  ]
                ),
              ]),
            ],
            1
          ),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }